export const MOBILE_MENU_ROOT = 'root';
export const MOBILE_MENU_FIRST = 'level1';
export const MOBILE_MENU_SECOND = 'level2';
export const MOBILE_MENU_THIRD = 'level3';
export const MOBILE_MENU_SERVICE = 'service';
export const MOBILE_MENU_STORE = 'store';
